import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ResumeCandidates } from '@/features/resume-candidates'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  filter: z.string().optional().catch(''),
  source: z.string().optional().catch(undefined),
  hasLinkedin: z.boolean().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/resume-candidates/')({
  validateSearch: searchSchema,
  component: ResumeCandidates,
})
